<template>
  <div class="main">
    <!-- <div class="steps clearfix text-center steps-header">
      <logo/>
    </div> -->
    <div class="container-fluid">
      <img
        src="https://www.youroverseashome.com/cdn-cgi/imagedelivery/ydQrSxxeWMqiiuwLdb7wWg/efe64c97-3cff-4bd7-9d35-f18ef8470d00/w=1500"
        class="img-bg"
      />
      <div class="container">
        <template v-if="!actions.showThankYouForYOH">
          <h2 class="reset-case">
            Our Webinars and Virtual Events are open to all, and access is
            complimentary thanks to our sponsor <br />
            <div id="banner" class="sponsor-container">
              <div>
                <img
                  src="/assets/img/logo.png"
                  title="Smart currency exchange"
                />
              </div>
            </div>
          </h2>
        </template>
        <template v-if="actions.showThankYouForYOH">
          <message-box
            type="3"
            :email="formData.email"
            :orderReference="generateUUID()"
          />
          <div
            class="alert alert-success text-center"
            role="alert"
            v-if="!skipSmartStep"
          >
            <b
              >You can also register with our sponsor Smart Currency Exchange to
              help you budget for your overseas property purchase</b
            >
          </div>
        </template>
        <template v-if="skipSmartStep && actions.showThankYouForYOH"
          ><div></div
        ></template>
        <template v-else>
          <form
            method="POST"
            id="signup-form"
            class="signup-form wizard clearfix"
            novalidate="novalidate"
            autocomplete="off"
          >
            <div class="steps clearfix">
              <ul ref="steps" role="tablist">
                <li
                  role="tab"
                  :class="{ current: tab.isActive }"
                  :aria-disabled="!tab.isActive"
                  :aria-selected="tab.isActive"
                  v-for="tab in tabs"
                  :key="tab.name"
                >
                  <a
                    ><span class="current-info audible"> </span
                    ><span class="title">
                      <span class="icon"><i :class="tab.icon"></i></span>
                      <span class="title_text text-center">{{ tab.name }}</span>
                    </span></a
                  >
                </li>
              </ul>
            </div>
            <div class="content clearfix">
              <div class="tab-content">
                <Webinar v-if="currentActive == 0" />
                <About v-else-if="currentActive == 1" />
                <Preference v-else-if="currentActive == 2" :prev="prev" ref="preference" />
                <Address v-else-if="currentActive == 3" />
              </div>
              <div class="col-sm-12 p-0 " v-if="!actions.hideNavigation">
                <message-info />
              </div>
              <div
                class="wizard-footer height-wizard mt-3"
                v-if="!actions.hideNavigation"
              >
                <div class="pull-right">
                  <input
                    type="button"
                    class="btn btn-next btn-fill btn-success btn-wd btn-md"
                    name="next"
                    value="Next"
                    @click="next()"
                  />
                </div>
                <div class="pull-left" v-if="currentActive > 0">
                  <input
                    type="button"
                    class="btn btn-previous btn-fill btn-default btn-wd btn-md"
                    name="previous"
                    value="Previous"
                    @click="prev()"
                  />
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </form>
        </template>
        <Loading v-if="loading" />
        <!-- end row -->
      </div>
    </div>
    <!--  big container -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Common } from "@/helper/common";
import MessageInfo from "@/components/ui/MessageInfo.vue";
import About from "@/components/steps/About.vue";
import moment from "moment";
import Address from "@/components/steps/Address.vue";
import Webinar from "@/components/steps/WebinarSelection.vue";
import Preference from "@/components/steps/Preference.vue";
import Loading from "@/components/ui/Loading.vue";
// import Logo from "@/components/ui/Logo.vue";
import axios from "axios";
import mixin from "@/components/shared/mixinUtility";
import MessageBox from "@/components/ui/MessageBox.vue";
import { trackPageChange } from "@/helper/freshRelevance";
import {
  trackFunnelStarted,
  trackStepCompleted,
  trackStepBack,
  trackValidationFailed,
  trackYohRegistrationCompleted,
} from "@/helper/datadog";

export default {
  name: "form-wizard",
  mixins: [mixin],
  data() {
    return {
      loading: false,
      existingClients: [211, 215, 216, 217, 218, 219, 220],
    };
  },
  computed: {
    ...mapGetters({
      tabs: "getTabs",
      currentActive: "getCurrentActive",
      totalTabs: "getTotalTabs",
      actions: "getActions",
      formData: "getFormData",
      contactId: "getContactId",
      mainContactId: "getMainContactId",
      showHeaderForSmart: "showHeaderForSmart",
      skipSmartStep: "skipSmartStep",
    }),
  },
  components: {
    "message-info": MessageInfo,
    About,
    Address,
    Webinar,
    Preference,
    Loading,
    "message-box": MessageBox,
  },
  mounted() {
    this.$store.dispatch("setTotalTabs", this.tabs.length);
    trackFunnelStarted();
  },
  created() {
    //custome validation for dob
    this.customValidationForDob();
  },
  methods: {
    generateUUID() {
      return crypto.randomUUID();
    },
    next() {
      //reset messageinfo
      this.resetMessageInfo();
      this.$root.$validator
        .validate("step" + (this.currentActive + 1) + ".*")
        .then(async (valid) => {
          if (valid) {
            try {
              if (this.currentActive == 0) {
                //just going next
                //set webinar source
                //check if webinare is selected
                if (!this.formData.webinar) {
                  //show message
                  this.showGenericErrorMessage(
                    "Please select a Webinar/Event first.",
                    false
                  );
                  return false;
                }
                this.$store.dispatch(
                  "setWebinarSource",
                  this.formData.webinar.sourceSite
                );
                this.goNext();
              } else if (this.currentActive == 1) {
                //validate mobile number
                let isValidNumber = await this.isValidMobileNumber();
                if (!isValidNumber) {
                  this.showGenericErrorMessage(
                    "Please enter a valid mobile number.",
                    false
                  );
                  return false;
                }
                //## Check existing client
                await this.firstStep();
              } else if (this.currentActive == 2) {
                //## Property plans
                if (!this.skipSmartStep) {
                  if (!this.$refs.preference.validateSelection()) {
                    this.showGenericErrorMessage(
                      "Please select a valid location from the list.",
                      false
                    );
                    return false;
                  }
                  //logic is in here /otherwise inside preference component
                  await this.secondStep();
                }
              }
            } catch (ex) {
              console.log(ex);
              //show some error
              this.showGenericErrorMessage(
                "We've encountered a problem.",
                false
              );
              this.loading = false;
            }
          } else {
            //form not valid
            this.showGenericErrorMessage(
              "Please enter all mandatory fields.",
              false
            );
            trackValidationFailed(this.currentActive, this.tabs[this.currentActive].name);
          }
        });
    },
    goNext() {
      if (this.currentActive === 2) {
        trackYohRegistrationCompleted();
      } else {
        trackStepCompleted(this.currentActive, this.tabs[this.currentActive].name);
      }
      this.$store.dispatch("setCurrentActive", this.currentActive + 1);
      this.tabs.forEach((tab) => {
        tab.isActive = false;
      });

      this.tabs[this.currentActive].isActive = true;
      Common.scrollBackUp();
      this.resetMessageInfo();
      trackPageChange();
    },
    prev() {
      //reset messageinfo
      this.resetMessageInfo();
      trackStepBack(this.currentActive, this.tabs[this.currentActive].name);
      this.$store.dispatch("setCurrentActive", this.currentActive - 1);
      this.$store.dispatch("setFinalStep", false);
      this.tabs.forEach((tab) => {
        tab.isActive = false;
      });
      this.tabs[this.currentActive].isActive = true;
      Common.scrollBackUp();
      trackPageChange();
    },
    customValidationForDob() {
      this.$validator.extend("minage", {
        // eslint-disable-next-line
        getMessage(field, val) {
          return "must be 18+";
        },
        // eslint-disable-next-line
        validate(value, field) {
          // eslint-disable-next-line
          var date = moment(value, "DD/MM/YYYY");
          if (date.isValid()) {
            var userDate = new Date(
              date.year() + 18,
              date.month(),
              date.date()
            );
            return userDate <= new Date();
          } else {
            return false;
          }
        },
      });
    },
    async firstStep() {
      this.loading = true;
      const resExistingContact = await this.checkContact();
      this.logApi({
        request: { email: this.formData.email },
        response: { data: resExistingContact.data },
      });
      //set token
      if (resExistingContact.data.token)
        await this.$store.dispatch(
          "setJwtToken",
          resExistingContact.data.token.access_token
        );
      this.loading = false;
      if (!resExistingContact.data.IsContactExists) {
        this.$store.dispatch("setContactExist", false);
        this.goNext();
      } else {
        //apply some rules
        if (
          this.existingClients.find(
            (ex) => ex == resExistingContact.data.StatusId
          )
        ) {
          //they will stop at step3 , no Smart account part , only enquiry/opportunity
          this.$store.dispatch("setSkipSmartStep", true);
        }
        //set contactId
        this.$store.dispatch("setContactId", resExistingContact.data.ContactId);
        //set maincontactId
        this.$store.dispatch(
          "setMainContactId",
          resExistingContact.data.MainContactId
        );

        this.$store.dispatch("setContactExist", true);
        this.goNext();
      }
    },
    async secondStep() {
      //we are ready to create/update a new contact
      this.loading = true;
      try {
        const resContact = await this.createContact();

        if (resContact.data.status == 0) {
          this.showGenericErrorMessage("We've encountered a problem.", false);
          this.loading = false;
          return false;
        } else {
          //set contactId
          //resContact.data.contactId;
          //set cookies - tracking
          Common.setCookie("email", this.formData.email, 30);
          Common.setCookie("firstname", this.formData.firstName, 30);
          Common.setCookie("lastname", this.formData.lastName, 30);
          Common.setCookie("title", this.formData.title, 30);
          Common.setCookie("mobilePrefix", this.formData.mobilePrefix, 30);
          Common.setCookie("mobile", this.formData.mobile, 30);
          this.$store.dispatch("setContactId", resContact.data.contactId);
          this.$store.dispatch(
            "setMainContactId",
            resContact.data.maincontactId
          );
          //set token
          if (resContact.data.token)
            await this.$store.dispatch(
              "setJwtToken",
              resContact.data.token.access_token
            );
          //check if any additional user
          if (resContact.data.additionalUserIds) {
            let addUserIds = resContact.data.additionalUserIds.split(",");
            if (addUserIds.length > 0)
              this.$store.dispatch(
                "setAdditionalContactId",
                parseInt(addUserIds[0])
              );
          }

          //create enquiry/opportunity
          await this.createEnquiryOppurtunity(this.formData.webinar, false);
          if (
            this.formData.virtualEventOptIn &&
            this.formData.virtualEventToOptin
          )
            // auto register to next virtual event
            this.createEnquiryOppurtunity(
              this.formData.virtualEventToOptin,
              true
            );
          this.goNext();
          this.loading = false;
        }
      } catch (ex) {
        //show some error
        this.showGenericErrorMessage("We've encountered a problem.", false);
        this.loading = false;
      }
      //}
    },
    async checkContact() {
      try {
        let formData = this.formData;
        //captcha
        // eslint-disable-next-line
        //grecaptcha.ready(function() {
        // eslint-disable-next-line
        const token = await grecaptcha.execute(
          "6LcgTAscAAAAALm_k6sF6J1pr1Eecw0FwnjRbuzm",
          { action: "submit" }
        );
        // eslint-disable-next-line
        if (document.querySelector(".g-recaptcha-response"))
          document.querySelector(".g-recaptcha-response").value = token;
        const { data } = await axios.get(
          process.env.VUE_APP_API_URL +
            "/client/contactAlreadyExists?email=" +
            formData.email +
            "&clientType=" +
            formData.clientType +
            "&bizID=" +
            formData.bizId,
          { headers: { token: token } }
        );
        return data;
        // });
      } catch (ex) {
        console.log("captcha", ex);
      }
    },
    async isValidMobileNumber() {
      let isValid = false;
      try {
        let formData = this.formData;
        //clean prefix
        let prefix =
          formData.mobilePrefix.indexOf("|") > -1
            ? formData.mobilePrefix.split("|")[1]
            : formData.mobilePrefix;
        const phoneNumber = prefix + formData.mobile;
        const { data } = await axios.post(
          process.env.VUE_APP_API_URL +
            "/client/ValidatePhoneNumber?phone=" +
            phoneNumber
        );
        isValid = data.isValid;
        return isValid;
      } catch (ex) {
        console.log("mobile validation error", ex);
        return false;
      }
    },
  },
};
</script>
